module.exports = __webpack_public_path__ + "static/media/icons.8e3c7f55.eot";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/icons.eot
// module id = 402
// module chunks = 0